var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmazingTitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 451,
    height: 99,
    viewBox: "0 0 451 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_352_130)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 51.657L25.9325 0.970739H26.9032L52.8357 51.657H42.2963L38.344 43.6831H14.4224L10.5394 51.657H0ZM19.1373 35.2238H33.629L26.4179 19.9001L19.1373 35.2238Z",
    fill: "url(#paint0_linear_352_130)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.303 0.970739V51.657H92.5952V26.0018L76.7168 45.0698L60.9077 26.0018V51.657H51.2003V0.970739H51.8244L76.7168 30.2315L101.679 0.970739H102.303Z",
    fill: "url(#paint1_linear_352_130)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.8579 51.657L125.79 0.970739H126.761L152.694 51.657H142.154L138.202 43.6831H114.28L110.397 51.657H99.8579ZM118.995 35.2238H133.487L126.276 19.9001L118.995 35.2238Z",
    fill: "url(#paint2_linear_352_130)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.314 2.14949L164.024 42.643H191.344V51.657H146.967V50.5476L175.327 9.91537H149.117V0.970739H192.314V2.14949Z",
    fill: "url(#paint3_linear_352_130)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.211 51.657H193.503V0.970739H203.211V51.657Z",
    fill: "url(#paint4_linear_352_130)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.113 51.657L217.692 21.4949V51.657H208.054V0.970739H209.094L242.445 31.6182V0.970739H252.153V51.657H251.113Z",
    fill: "url(#paint5_linear_352_130)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.843 23.9217C304.797 24.8924 304.773 25.7938 304.773 26.6259C304.727 27.3655 304.704 28.1051 304.704 28.8447C304.704 29.5381 304.681 30.0697 304.635 30.4395C304.357 33.629 303.479 36.5875 302 39.3148C300.567 42.0421 298.695 44.3996 296.384 46.3873C294.118 48.3287 291.484 49.8542 288.479 50.9636C285.521 52.073 282.4 52.6277 279.118 52.6277C275.513 52.6277 272.115 51.9343 268.926 50.5476C265.736 49.1608 262.939 47.2887 260.536 44.9312C258.178 42.5274 256.306 39.7308 254.919 36.5412C253.533 33.3517 252.839 29.9541 252.839 26.3485C252.839 22.7429 253.533 19.3454 254.919 16.1558C256.306 12.92 258.178 10.1234 260.536 7.76588C262.939 5.36216 265.736 3.46691 268.926 2.08015C272.115 0.693383 275.513 0 279.118 0C283.695 0 287.878 1.06319 291.669 3.18956C295.505 5.31593 298.602 8.1588 300.96 11.7182L292.639 16.7799C291.16 14.6073 289.219 12.7813 286.815 11.3021C284.457 9.82292 281.892 9.08331 279.118 9.08331C276.807 9.08331 274.634 9.56868 272.6 10.5394C270.613 11.4639 268.856 12.712 267.331 14.2837C265.852 15.8553 264.673 17.7044 263.795 19.8307C262.916 21.9109 262.477 24.0835 262.477 26.3485C262.477 28.6598 262.916 30.8555 263.795 32.9357C264.673 35.0158 265.852 36.8417 267.331 38.4134C268.856 39.985 270.613 41.2562 272.6 42.227C274.634 43.1515 276.807 43.6137 279.118 43.6137C280.875 43.6137 282.562 43.3595 284.18 42.851C285.798 42.2963 287.277 41.5336 288.618 40.5629C289.958 39.5921 291.114 38.4365 292.085 37.096C293.101 35.7554 293.841 34.2762 294.303 32.6583H275.582V23.9217H304.843Z",
    fill: "url(#paint6_linear_352_130)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.02 43.059V51.657H321.479V0.901398H331.186V43.059H358.02Z",
    fill: "url(#paint7_linear_352_130)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.605 51.657H357.897V0.970739H367.605V51.657Z",
    fill: "url(#paint8_linear_352_130)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.456 9.56868V22.0496H406.932V30.9942H382.456V51.657H372.749V0.901398H410.053V9.56868H382.456Z",
    fill: "url(#paint9_linear_352_130)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.691 9.49934V22.1882H444.236V30.9942H419.691V42.9204H447.357V51.657H410.053V0.901398H447.357V9.49934H419.691Z",
    fill: "url(#paint10_linear_352_130)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.849 99.0007H152.211V48.2451H175.231C177.82 48.2451 180.177 48.6842 182.304 49.5625C184.476 50.3946 186.325 51.5964 187.851 53.1681C189.376 54.6935 190.555 56.5426 191.387 58.7152C192.265 60.8415 192.704 63.1759 192.704 65.7183C192.704 69.555 191.734 72.9064 189.792 75.7724C187.897 78.6383 185.355 80.6954 182.165 81.9435C186.464 87.583 190.694 93.2687 194.854 99.0007H183.274C181.241 96.3658 179.253 93.7078 177.311 91.0268C175.37 88.3457 173.428 85.6184 171.487 82.8448H161.849V99.0007ZM161.849 74.2469H175.231C176.11 74.2469 177.011 74.0851 177.935 73.7615C178.906 73.3917 179.761 72.8601 180.501 72.1668C181.241 71.4272 181.841 70.5258 182.304 69.4626C182.812 68.3994 183.066 67.1513 183.066 65.7183C183.066 64.9787 182.974 64.1004 182.789 63.0835C182.604 62.0665 182.234 61.0958 181.68 60.1713C181.125 59.2467 180.339 58.4609 179.322 57.8138C178.305 57.1666 176.942 56.843 175.231 56.843H161.849V74.2469Z",
    fill: "url(#paint11_linear_352_130)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.608 48.2451C233.104 48.2451 235.438 48.7304 237.611 49.7012C239.83 50.6257 241.748 51.8969 243.366 53.5148C244.984 55.1327 246.255 57.051 247.18 59.2699C248.15 61.4425 248.636 63.7768 248.636 66.273C248.636 68.7692 248.22 71.0805 247.388 73.2068C246.556 75.3332 245.331 77.2054 243.713 78.8232C242.095 80.3949 240.038 81.643 237.542 82.5675C235.092 83.4458 232.249 83.8849 229.013 83.8849H217.711V99.0007H208.004V48.2451H230.608ZM230.608 75.1483C232.041 75.1483 233.289 74.9172 234.352 74.4549C235.415 73.9464 236.271 73.2762 236.918 72.4441C237.611 71.6121 238.12 70.6644 238.443 69.6012C238.767 68.5381 238.928 67.4287 238.928 66.273C238.928 65.1174 238.72 63.9849 238.304 62.8754C237.888 61.7198 237.287 60.7028 236.502 59.8246C235.716 58.9463 234.745 58.2298 233.589 57.6751C232.434 57.1204 231.093 56.843 229.568 56.843H217.711V75.1483H230.608Z",
    fill: "url(#paint12_linear_352_130)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.711 70.2947C305.665 71.2654 305.642 72.1668 305.642 72.9989C305.595 73.7385 305.572 74.4781 305.572 75.2177C305.572 75.9111 305.549 76.4427 305.503 76.8125C305.226 80.002 304.347 82.9605 302.868 85.6878C301.435 88.4151 299.563 90.7726 297.252 92.7603C294.987 94.7017 292.352 96.2272 289.347 97.3366C286.389 98.446 283.268 99.0007 279.986 99.0007C276.381 99.0007 272.983 98.3073 269.794 96.9205C266.604 95.5338 263.808 93.6617 261.404 91.3042C259.046 88.9004 257.174 86.1038 255.787 82.9142C254.401 79.7247 253.707 76.3271 253.707 72.7215C253.707 69.1159 254.401 65.7184 255.787 62.5288C257.174 59.293 259.046 56.4964 261.404 54.1389C263.808 51.7351 266.604 49.8399 269.794 48.4531C272.983 47.0664 276.381 46.373 279.986 46.373C284.563 46.373 288.746 47.4362 292.537 49.5625C296.373 51.6889 299.471 54.5318 301.828 58.0911L293.507 63.1528C292.028 60.9802 290.087 59.1543 287.683 57.6751C285.325 56.1959 282.76 55.4563 279.986 55.4563C277.675 55.4563 275.503 55.9417 273.469 56.9124C271.481 57.8369 269.724 59.085 268.199 60.6567C266.72 62.2283 265.541 64.0773 264.663 66.2037C263.784 68.2839 263.345 70.4565 263.345 72.7215C263.345 75.0328 263.784 77.2285 264.663 79.3086C265.541 81.3888 266.72 83.2147 268.199 84.7864C269.724 86.358 271.481 87.6292 273.469 88.6C275.503 89.5245 277.675 89.9867 279.986 89.9867C281.743 89.9867 283.43 89.7325 285.048 89.224C286.666 88.6693 288.145 87.9066 289.486 86.9359C290.826 85.9651 291.982 84.8095 292.953 83.4689C293.97 82.1284 294.709 80.6492 295.172 79.0313H276.45V70.2947H305.711Z",
    fill: "url(#paint13_linear_352_130)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_352_130",
    x: 0,
    y: 0,
    width: 450.357,
    height: 99.001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.395833 0 0 0 0 0.0610243 0 0 0 0 0.0610243 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_352_130"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_352_130",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_352_130",
    x1: 0.00000434466,
    y1: 18.4519,
    x2: 233.94,
    y2: 274.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED826E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E14E38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_352_130",
    x1: 0.00000434466,
    y1: 18.4519,
    x2: 233.94,
    y2: 274.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED826E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E14E38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_352_130",
    x1: 0.00000434466,
    y1: 18.4519,
    x2: 233.94,
    y2: 274.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED826E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E14E38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_352_130",
    x1: 0.00000434466,
    y1: 18.4519,
    x2: 233.94,
    y2: 274.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED826E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E14E38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_352_130",
    x1: 0.00000434466,
    y1: 18.4519,
    x2: 233.94,
    y2: 274.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED826E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E14E38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_352_130",
    x1: 0.00000434466,
    y1: 18.4519,
    x2: 233.94,
    y2: 274.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED826E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E14E38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_352_130",
    x1: 0.00000434466,
    y1: 18.4519,
    x2: 233.94,
    y2: 274.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED826E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E14E38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_352_130",
    x1: 0.00000434466,
    y1: 18.4519,
    x2: 233.94,
    y2: 274.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED826E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E14E38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_352_130",
    x1: 0.00000434466,
    y1: 18.4519,
    x2: 233.94,
    y2: 274.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED826E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E14E38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_352_130",
    x1: 0.00000434466,
    y1: 18.4519,
    x2: 233.94,
    y2: 274.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED826E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E14E38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_352_130",
    x1: 0.00000434466,
    y1: 18.4519,
    x2: 233.94,
    y2: 274.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED826E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E14E38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_352_130",
    x1: 0.00000434466,
    y1: 18.4519,
    x2: 233.94,
    y2: 274.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED826E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E14E38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_352_130",
    x1: 0.00000434466,
    y1: 18.4519,
    x2: 233.94,
    y2: 274.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED826E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E14E38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_352_130",
    x1: 0.00000434466,
    y1: 18.4519,
    x2: 233.94,
    y2: 274.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED826E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E14E38"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmazingTitle);
export default __webpack_public_path__ + "static/media/amazing_title.fd2d1aa4a7ad5a4dc6d477e6d7ed874d.svg";
export { ForwardRef as ReactComponent };